import { Redirect, useLocalSearchParams } from "expo-router";

const DetailedListItemsRedirect = () => {
	const { id, examName } = useLocalSearchParams<{
		id: string;
		examName?: string;
	}>();

	return (
		<Redirect
			href={{
				pathname: "/(protected)/session/[id]/report/items",
				params: { id, examName: examName ?? "" },
			}}
		/>
	);
};

export default DetailedListItemsRedirect;
